export default __webpack_public_path__ + "static/media/newzeland.8571ed74.svg";